module.exports = __webpack_public_path__ + "img/flower-daffodil.f636d098.svg";